import { zUid } from "src/types/zUid";
import z from "zod";

export const zTechpackSettings = z.object({
  techpackObjectId: zUid.nullable(),
  techpackUrl: z.string().nullable(),
  articleAttributeId: zUid.optional().nullable(),
  exportFileNameAttributeId: zUid.optional().nullable(),
  supplierObjectId: zUid.optional().nullable(),
  supplierNameAttributeId: zUid.optional().nullable(),
  sketchPositionAttrId: zUid.array().optional().nullable(),
  patternFileAttrId: zUid.array().optional().nullable(),
  bomBusinessServiceId: zUid.optional().nullable(),
  createArchiveAttrId: zUid.nullish().describe("Атрибут 'Формировать архив'"),
});

export type ZTechpackSettings = z.infer<typeof zTechpackSettings>;
